import React from 'react';
import {hydrate} from "react-dom";
import {createRoot} from "react-dom/client";
import reportWebVitals from './reportWebVitals';
import Site from "./Site";
import {EnvironmentProvider} from "./context/EnvironmentProvider";
import _environment from "./environments/SiteEnvironment";
import _device_service from "./services/DeviceService";
import './index.scss';

const rootElement = document.getElementById('root') as HTMLElement;

const ChaseTheFoxSite = () => {
    return <Site />;
}

createRoot(rootElement).render(
    <React.StrictMode>
        <EnvironmentProvider env={_environment}>
            <ChaseTheFoxSite/>
        </EnvironmentProvider>
    </React.StrictMode>
);
if (_device_service.isCrawler()) {
    hydrate(
        <React.StrictMode>
            <ChaseTheFoxSite/>
        </React.StrictMode>,
    rootElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
